"use client";

import React from 'react';
import clsx from 'clsx';
import { ConditionalLink } from '@/app/lib/ConditionalLink';
import { isFilled } from '@prismicio/helpers';
import { RichText } from '@/app/lib/RichText';
import { dashify, sliceStyle } from '@/app/lib/utils';
import { RevealOnScroll } from '@/app/lib/RevealOnScroll';
import { RevealTitle } from '@/app/lib/RevealTitle';
import { BackgroundImage } from "@/app/lib/ParallaxBackground";
import sharedStyles from '@/app/shared.module.scss';
import styles from './ticketOptions.module.scss';

const TicketOptions = ({ slice }) => {

	return (
		<BackgroundImage slicePrimary={slice?.primary}>
			<div className={clsx(styles.ticket_options)} style={sliceStyle(slice?.primary)}>

				{/* title */}
				<div className={clsx(sharedStyles.top)}>
					<div className={clsx(sharedStyles.left)}>
						{isFilled.keyText(slice?.primary?.title) && (
							<h1 className={clsx(sharedStyles.h1)} id={dashify(slice?.primary?.title)}>
								<RevealTitle size='small'>{slice?.primary?.title}</RevealTitle>
							</h1>
						)}
					</div>
				</div>

				{/* options */}
				{slice?.primary?.options.length > 0 ? (
					<div className={clsx(styles.options)}>
						{slice?.primary?.options.map((option, index) => {
							return (
								<RevealOnScroll scrollDelayRem={(index % 4) * 5} key={index}>
									<div className={clsx(styles.option)}>

										<div className={clsx(styles.top)}>

											{isFilled.richText(option?.title) && (
												<div className={clsx(styles.title)}>
													<RichText field={option?.title} />
												</div>
											)}

											{isFilled.richText(option?.content) && (
												<div className={clsx(styles.content)}>
													<RichText field={option?.content} />
												</div>
											)}

											<div className={clsx(styles.price)}>
												{isFilled.number(option?.price) && (

													<div className={clsx(styles.left)}>
														<h3 className={clsx(styles.current)}>${option?.price}</h3>
														{isFilled.number(option?.previous_price) && (
															<h5 className={clsx(styles.previous)}>Reg. ${option?.previous_price}</h5>
														)}
													</div>
												)}

												<ConditionalLink
													url={option?.link}
													squadupeventid={slice?.primary?.squadup_event_id}
													condition={isFilled.link(option?.link) || isFilled.keyText(slice?.primary?.squadup_event_id)}
													className={clsx(styles.link)}
													style={{ backgroundColor: option?.link_background_color ? option?.link_background_color : '#77f252' }}>
													<span className={clsx(styles.hoverBg)} style={{ backgroundColor: option?.link_background_hover_color ? option?.link_background_hover_color : '#eb008c' }} />
													<div className={clsx(styles.inner, styles.space)}>
														<span style={{ color: option?.link_text_color ? option?.link_text_color : '#000' }}>{option?.link?.text || 'Buy tickets'}</span>
													</div>
													<div className={clsx(styles.inner, styles.initial)}>
														<span style={{ color: option?.link_text_color ? option?.link_text_color : '#fff' }}>{option?.link?.text || 'Buy tickets'}</span>
													</div>
													<div className={clsx(styles.inner, styles.second)}>
														<span style={{ color: option?.link_text_hover_color ? option?.link_text_hover_color : '#000' }}>{option?.link?.text || 'Buy tickets'}</span>
													</div>
												</ConditionalLink>

											</div>
										</div>
									</div>
								</RevealOnScroll>
							);
						})}
					</div>
				) : null}
			</div>
		</BackgroundImage>
	);
}

export default TicketOptions;